import {
    ADD_PIN,
    ADD_PIN_SUCCESS,
    ADD_PIN_ERROR,
    ADD_PINS,
    ADD_PINS_SUCCESS,
    ADD_PINS_ERROR,
    ADD_PIN_IMAGE,
    ADD_PIN_IMAGE_ERROR,
    ADD_PIN_IMAGE_SUCCESS,
    GET_PINS,
    GET_PINS_ERROR,
    GET_PINS_SUCCESS,
    GET_PINS_FILTER,
    GET_PINS_FILTER_SUCCESS,
    GET_PINS_FILTER_ERROR

} from "../constants/pinsConstants";

const initialState = {
    loading: false,
    success: false,
    error: '',
    loadingTitle: '',
    loadingMessage: ''
};


function pinsReducer(state = initialState, action) {
    switch (action.type) {
        case ADD_PIN:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'PINS',
                'loadingMessage': 'THE PIN IS BEING SAVED',
                'type': action.type
            });
        case ADD_PIN_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case ADD_PIN_SUCCESS:
            let AddPinData = state.pinData ? [...state.pinData] : []
            AddPinData.push(action.data);

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'pinData': AddPinData,
                'type': action.type
            });
        case ADD_PINS:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'PINS',
                'loadingMessage': 'THE PINS IS BEING SAVED',
                'type': action.type
            });
        case ADD_PINS_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case ADD_PINS_SUCCESS:
            let MultipleAddedPinData = state.pinData ? [...state.pinData] : []
            MultipleAddedPinData.push(action.data);

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'pinData': MultipleAddedPinData,
                'type': action.type
            });
        case ADD_PIN_IMAGE:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'PINS',
                'loadingMessage': 'THE PIN IMAGE IS BEING UPLOADED',
                'type': action.type
            });
        case ADD_PIN_IMAGE_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action
            });
        case ADD_PIN_IMAGE_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'url': action.data
            });
        case GET_PINS:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'PINS',
                'loadingMessage': 'PINS ARE BEING LOADED',
                'type': action.type
            });
        case GET_PINS_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case GET_PINS_SUCCESS:
            let pinData = [];
            if (action && action.data && Array.isArray(action.data)) {
                pinData = action.data;
            }

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'pinData': pinData,
                'type': action.type
            });
        case GET_PINS_FILTER:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'PINS',
                'loadingMessage': 'PINS ARE BEING LOADED',
                'type': action.type
            });
        case GET_PINS_FILTER_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case GET_PINS_FILTER_SUCCESS:
            let pinFilteredData = [];
            if (action && action.data && Array.isArray(action.data)) {
                pinFilteredData = action.data;
            }

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'pinData': pinFilteredData,
                'type': action.type
            });
        default:
            return state;
    }
}

export default pinsReducer;